
export default `
<p align="center">
 <img src="https://github.com/danielsnider/cell-bio/raw/master/images/tracking_dpc2.gif?raw=true"
  style='width: calc(56%);
      margin-left: -15px;
      margin-top: -17px;'
 >
 <img src="https://github.com/danielsnider/cell-bio/blob/master/images/tracking_traces.gif?raw=true"
  style='width: calc(46%);
      margin-top: -17px;
      margin-right: -15px;'
 >
</p>

### Published Journal Article:

Anzi, Shira et al. (2018). **Postnatal Exocrine Pancreas Growth by Cellular Hypertrophy Correlates with a Shorter Lifespan in Mammals**. Developmental Cell, Volume 45, Issue 6, 726-737

I contributed figures, statistics, and image analysis to the surprising discovery that acinar cell size from many different animal species is strongly correlated with life span.

<p align="center">
 <img src="https://github.com/danielsnider/cell-bio/raw/master/images/my_contribution.jpg" alt="Drawing" width="100%">
 </p>

Journal Article: [https://www.cell.com/developmental-cell/abstract/S1534-5807(18)30417-9](https://www.cell.com/developmental-cell/abstract/S1534-5807(18)30417-9)

Full source code: [https://github.com/danielsnider/E-cadherin-Cell-Size](https://github.com/danielsnider/E-cadherin-Cell-Size)


### Outlier Analysis

Investigating the trends seen in the localization of protein signal inside single cells. Hundreds of thousands of cells were segmented and we can choose to observe any sub-population.

<p align="center">
 <img src="https://github.com/danielsnider/cell-bio/blob/master/images/outlier_investigation.gif?raw=true" width="100%">
 <img src="https://github.com/danielsnider/cell-bio/blob/master/images/STRADa_nuc_vs_cell_mass_bins29_hidepoints_true.png?raw=true" width="100%">
</p>

Project homepage: [https://github.com/danielsnider/Outlier-Analysis](https://github.com/danielsnider/Outlier-Analysis)


### Cell Size Variety in Histology of Many Animal Species

<p align="center">
 <img src="https://github.com/danielsnider/cell-bio/blob/master/images/side-by-side_zoo-animal-segmentation_ecad%20compressed.gif?raw=true" width="90%">
 <img src="https://github.com/danielsnider/cell-bio/raw/master/images/colorbar.PNG?raw=true" width="8.2%">
</p>

Project homepage: [https://github.com/danielsnider/E-cadherin-Cell-Size](https://github.com/danielsnider/E-cadherin-Cell-Size)


### 3D Measurements of Cells in Pancreatic Islets of Mice

<p align="center">
 <img src="https://raw.githubusercontent.com/danielsnider/cell-bio/master/images/islet-segmentation2.gif" width="48%">
 <img src="https://github.com/danielsnider/cell-bio/blob/master/images/3d_islet2.gif?raw=true" width="48%">
</p>

Project homepage: [https://github.com/danielsnider/Cell-3D-Image-Analysis](https://github.com/danielsnider/Cell-3D-Image-Analysis)

### Kidney Substructure Segmentation in Electron Microscopy

The green area is the glomerular basement membrane and each colored contour line is a podocyte foot process.

<p align="center">
 <img src="https://github.com/danielsnider/cell-bio/blob/master/images/EMResults2.gif?raw=true" width="99%">
</p>

Project homepage: [https://github.com/danielsnider/TEM-glomerular-basement-segmentation](https://github.com/danielsnider/TEM-glomerular-basement-segmentation)

### Interaction of organelles inside single cells
<p align="center">
 <img src="https://github.com/danielsnider/cell-bio/raw/master/images/0_gif_distance_visualization%20type_zoom_decon%20cell_001-2.gif?raw=true" width="98%">
 <img src="https://github.com/danielsnider/cell-bio/blob/master/images/distance_plot.PNG?raw=true" width="98%">
 <img src="https://github.com/danielsnider/cell-bio/raw/master/images/pero_mito_zoom2.jpg?raw=true" width="50%">
 <img src="https://github.com/danielsnider/cell-bio/blob/master/images/0_gif_rotate%20type_zoom_decon%20cell_001%20compressed2.gif?raw=true" width="46%">
</p>

Project homepage: [https://github.com/danielsnider/peroxi_mito_analysis](https://github.com/danielsnider/peroxi_mito_analysis)

`;
